import AppBar from '@mui/material/AppBar';
import React, {useEffect} from 'react';
import {Outlet, useLocation, useNavigate} from 'react-router-dom';
import '../../App.css';
import {logout} from '../../api/auth';
import logoImage from '../../assets/images/forest-logo.png';
import {useAddepar} from '../../hooks/use-adepar';
import {useAuth} from '../../hooks/use-auth';
import {useBill} from '../../hooks/use-bill';
import {useBridge} from '../../hooks/use-bridge';
import {usePlaid} from '../../hooks/use-plaid';

function Navbar({user, children}) {
  const {
    state: {profile},
    getProfile,
  } = useAuth();
  const {fetchInitialFromDB} = usePlaid();
  const {fetchInitialBill} = useBill();
  const {fetchInitialAddepar} = useAddepar();
  const {fetchInitialBridge} = useBridge();

  const admin = !!profile.admin;

  useEffect(() => {
    if (user?.uid) {
      // ONLY PULL CURRENT USER INFO IF NOT ADMIN
      if (!admin) {
        fetchInitialFromDB(user.uid);
        fetchInitialBill(user.uid);
        fetchInitialAddepar(user.uid);
        fetchInitialBridge(user.uid);
      }
      getProfile(user.uid);
    }
  }, [user?.uid]);

  return (
    <div>
      <AppBar position="static" sx={{backgroundColor: '#f6f6f6'}}>
        <div className="flex-row justify-between align-center">
          <img
            alt="Forest Connect Logo"
            className="logo-image"
            style={{width: '200px', height: '58px'}}
            src={logoImage}
          />
          {user ? admin ? <AdminBar /> : <UserBar /> : null}
        </div>
      </AppBar>
      {children || <Outlet />}
    </div>
  );
}

const AdminBar = () => {
  const {reset} = useAuth();
  const {resetPlaid} = usePlaid();
  const navigate = useNavigate();

  const logOut = async () => {
    await logout();
    reset();
    resetPlaid();
    navigate('/');
  };

  return (
    <div className="flex-row">
      <button
        className="gray-button"
        onClick={() => {
          navigate('/admin/user/dashboard');
        }}>
        Users
      </button>
      <button
        className="gray-button"
        onClick={() => {
          navigate('/admin/client/dashboard');
        }}>
        Clients
      </button>
      <button className="gray-button" onClick={logOut}>
        Log out
      </button>
    </div>
  );
};

const UserBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const logOut = async () => {
    await logout();
    navigate('/');
  };

  const onAddConnectionPage = location.pathname === '/add-connection';

  return (
    <div className="flex-row">
      <button
        className="green-button"
        onClick={() =>
          navigate(onAddConnectionPage ? '/dashboard' : '/add-connection')
        }>
        {onAddConnectionPage ? 'Current Connections' : 'Add Connection'}
      </button>
      <button className="gray-button" onClick={logOut}>
        Log out
      </button>
    </div>
  );
};

export default Navbar;
